import { Paginator } from 'primereact/paginator'
import React, { useEffect, useRef, useState } from 'react'
import './pagination-component.scss'

const PaginatorComponent = ({
	currentPage,
	pageIndex,
	rowCount,
	totalRecords,
	onPageIndexChange,
	pageReset,
	isHotUpdateNeeded
}) => {
	const [first, setFirst] = useState(currentPage)
	const [page, setPage] = useState(pageIndex)
	const [rows, setRows] = useState(rowCount)
    const [pageLinks, setPageLinks] = useState(5)

    useEffect(() => {
        // Set pageLinks: 2 for mobile, else show all pages if less than 5, otherwise 5
        const handleResize = () => {
            if (window.innerWidth <= 768) {
                setPageLinks(2)
            } else {
                const totalPages = Math.ceil(totalRecords / rowCount)
                setPageLinks(totalPages < 5 ? totalPages : 5)
            }
        }
        handleResize()
        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [totalRecords, rowCount])

	useEffect(() => {
		if(pageReset){
			setFirst(1)
		}
	},[pageReset])

	const onPageChange = (e) => {
		setFirst(e.first)
		setPage(e.page + 1)
		onPageIndexChange(e.page + 1, e.first)
	}

	useEffect(() => { if (isHotUpdateNeeded) { setFirst(currentPage === 0 ? currentPage : (currentPage - 1) * rowCount); } }, [currentPage])

	return (
		<Paginator
			first={first}
			rows={rows}
			totalRecords={totalRecords}
			onPageChange={onPageChange}
			pageLinkSize={pageLinks}
		/>
	)
}
export default PaginatorComponent
